export default __webpack_public_path__ + "static/tip4-194563d152a27a5076c55dee1dad8e2e.png";